import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import debounce from 'lodash/debounce';

import { SCROLL_HEIGHT_TO_SHOW_BACKTOTOP } from '../../../config/constants.js';
import {
    getIsBackToTopButtonShown
} from '../../../redux/modules/backToTop/selectors';
import {
    showBackToTopButton,
    hideBackToTopButton
} from '../../../redux/modules/backToTop/actions';

import RoundButton from '../roundButton/RoundButton';
import { ArrowUpIcon } from '../SvgIcons';
import { scrollToTop } from '../../../helpers';
import ChatBoxWrapper from '@client/components/shared/chatbox';

import styles from './styles.scss';

export class BottomBubble extends Component {

    constructor(props) {
        super(props);
        this.checkBackToTopStateOnScroll = debounce(this.checkBackToTopStateOnScroll.bind(this), 100);
    }

    render() {
        const { isBackToTopButtonShown } = this.props;

        return (
            <div styleName="wrapper">
                <ChatBoxWrapper />
                <div styleName={classNames('arrow', { visible: isBackToTopButtonShown })}>
                    <RoundButton
                        icon={<ArrowUpIcon className={styles.icon} />}
                        onClick={this.scrollToTop}
                        onTouchEnd={this.scrollToTop}
                    />
                </div>
            </div>
        );
    }

    componentDidMount() {
        window.addEventListener('scroll', this.checkBackToTopStateOnScroll);
        this.checkBackToTopStateOnScroll();
    }


    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkBackToTopStateOnScroll);
    }

    checkBackToTopStateOnScroll() {
        const { isBackToTopButtonShown } = this.props;
        if (window.scrollY > SCROLL_HEIGHT_TO_SHOW_BACKTOTOP) {
            if (!isBackToTopButtonShown) {
                this.props.showBackToTopButton();
            }
        }
        else {
            this.props.hideBackToTopButton();
        }
    }

    scrollToTop() {
        scrollToTop();
    }
}

BottomBubble.propTypes = {
    showBackToTopButton: PropTypes.func.isRequired,
    hideBackToTopButton: PropTypes.func.isRequired,
    isBackToTopButtonShown: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
    isBackToTopButtonShown: getIsBackToTopButtonShown(state)
});

export default connect(
    mapStateToProps,
    {
        showBackToTopButton,
        hideBackToTopButton
    }
)(CSSModules(BottomBubble, styles, { allowMultiple: true }));
